import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/aiAoxphTtZMJYC7JTizVDH/Mockup_stiker.png';
const CHECKOUT_ORIGIN = 'https://biblioteca-de-los-chakras.impultienda.ar';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'Biblioteca Maestra del Código de los Chakras — Dominá tu conocimiento';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'Biblioteca Maestra del Código de los Chakras: 6 Módulos, 475 páginas y 5 bonos imprimibles. Todo tu conocimiento energético organizado en un solo lugar por 17 USD. Pagas en tu moneda local.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#06040F'
    });
    // Social preview
    ensureMeta({
      property: 'og:title',
      content: 'Biblioteca Maestra del Código de los Chakras™'
    });
    ensureMeta({
      property: 'og:description',
      content: '6 Módulos · 475 páginas · 5 Bonos imprimibles. TODO organizado, listo para dominar.'
    });
    ensureMeta({
      property: 'og:image',
      content: HERO_IMAGE
    });
    ensureMeta({
      property: 'og:type',
      content: 'product'
    });
    ensureMeta({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup + bonus covers
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_IMAGE,
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    // Performance: resolve the pixel host early without blocking the paint
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandViolet selection:text-white notranslate" data-id="element-0" data-mp="h7c6b1u3eh8c">
      <MetaPixel data-id="element-1" data-mp="c66dl40fmtyt" />
      <SocialProofPopup data-id="element-2" data-mp="19vzt51uhpeo0" />
      <ExitIntentModal data-id="element-3" data-mp="19w9oz627ug1m" />
      <main data-id="element-4" data-mp="19vhqnnh8i47n">
        <Hero data-id="element-5" data-mp="19v8aerlzrbf5" />
        <SocialProof data-id="element-6" data-mp="19tnhf6fbs0je" />
        <Testimonials1 data-id="element-7" data-mp="14x6j5jeew5sl" />
        <Problem data-id="element-8" data-mp="14xycsoog7tg8" />
        <ProductTomos data-id="element-9" data-mp="14xg956zgicya" />
        <Bonuses data-id="element-10" data-mp="14utzn1t09ndf" />
        <UrgencyCounter data-id="element-11" data-mp="zxttys02immu" />
        <Pricing data-id="element-12" data-mp="zx29ac80e9bc" />
        <Testimonials2 data-id="element-13" data-mp="zwiq6s6mhevq" />
        <Guarantee data-id="element-14" data-mp="zzwva86o826v" />
        <FAQ data-id="element-15" data-mp="vw8nppi1h6lm" />
        <CostOfNotHaving data-id="element-16" data-mp="vwibd6fm31o5" />
        <FinalCTA data-id="element-17" data-mp="vv70ynrnuvo2" />
      </main>
      <Footer data-id="element-18" data-mp="vvyrvlabc580" />
    </div>;
}